import { io } from "socket.io-client";
import { BASE_URL } from "./config";


const SOCKET_URL = BASE_URL;


const socket = io(SOCKET_URL, {
    transports: ['websocket'],
    autoConnect: false
})


class SocketIo {
    connectToSocket = (api_token?: string, callback = () => { }, success = () => { }) => {
        socket.io.opts.query = {
            authorization: api_token
        }
        socket.connect();
        socket.on('connect', () => {
            success()
        })

        socket.on('connect_error', function () {
            callback()
        });
    }
    emit = (eventName: string, params = {}, onSuccess = () => { }) => {
        socket.emit(eventName, params, () => {
            onSuccess();
        })
    }

    on<T = unknown>(eventName: string, callback: (data: T) => void): void {
        socket.on(eventName, callback)
    }


    dispose = (eventName: string) => {
        socket.off(eventName);
    }

    disconnect = () => {
        socket.disconnect();
    }

    getStatus = () => {
        return socket.connected
    }
}

export default new SocketIo();